import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';

// components
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Input,
  Button,
  Spinner
} from "reactstrap";
import Select from 'react-select'

import { Map, TileLayer, Marker} from 'react-leaflet'

// style
import "../../../assets/css/loading.css";

// helpers
import {InputCNPJ} from "../../../helpers/mask.js";
import {InputCEP} from "../../../helpers/mask.js";
import { icon_destino } from "../../../helpers/icons";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET, api_GETExternal, api_POST, api_PUT } from "../../../services/api_service.js";
import { getSessionCookie } from "../../../services/session.js";

export default function DestinosForm({history, handleReturn, item}) {
    const session = getSessionCookie();

    const { register, handleSubmit, errors, setError, setValue, clearErrors, getValues } = useForm({ mode: "onBlur" });
    
    const [showLoading, setshowLoading] = React.useState(false);

    const options_status = [        
        { value: 'Ativo', label: 'Ativo' },
        { value: 'Inativo', label: 'Inativo' }
    ];
    const [status, setStatus] = React.useState("");
    const handleStatus = (value) => {
        setStatus(value);
        clearErrors("status");
    }

    const [cnpj, setCnpj] = React.useState("");
    const handleCNPJ = (event) => {
        setCnpj(event.target.value);
        clearErrors("cnpj");
    }

    const options_comprovanteDestinacao = [
        { value: 'Foto', label: 'Foto' },
        { value: 'QRCode', label: 'QRCode' }
    ]

    const [comprovanteDestinacao, setComprovanteDestinacao] = React.useState("");
    const handleComprovanteDestinacao = (value) => {
        setComprovanteDestinacao(value);
        clearErrors("comprovanteDestinacao");
    }

    const [positionEndereco, setPositionEndereco] = React.useState([-3.755019499914185,-38.5860013961792]);
    const [center, setCenter] = React.useState([-3.755019499914185,-38.5860013961792]);
    const [cep, setCep] = React.useState("");
    const handleCEP = (event) => {        
        clearErrors("cep");
        setCep(event.target.value.replace("-", ""));                

        if (event.target.value.length != 9)
            return;
        
        setshowLoading(true);
        api_GETExternal(`https://viacep.com.br/ws/${event.target.value.replace("-", "")}/json/`).then(result => {            
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", "Cep não localizado", 'warning', null);
                setValue("logradouro", "");
                setValue("bairro", "");
                setValue("cidade", "");
                setValue("uf", "");
            }
            else{                
                setValue("logradouro", result.data.logradouro);
                setValue("bairro", result.data.bairro);
                setValue("cidade", result.data.localidade);
                setValue("uf", result.data.uf);                
                let chave = result.data.logradouro.replaceAll(" ", "+") + "," + result.data.bairro.replaceAll(" ", "+") + result.data.localidade.replaceAll(" ", "+");
                UpdatePositionEndereco(chave);
            }
          });
    }
    const handleNumeroEndereco = (event) => {
        let numero = event.target.value;
        if (numero != "")
        {
            let data = getValues();            
            let chave = data.logradouro.replaceAll(" ", "+") + "," + numero + "," + data.bairro.replaceAll(" ", "+") + data.cidade.replaceAll(" ", "+");
            UpdatePositionEndereco(chave);
        }
    }

    const UpdatePositionEndereco = (chave) => {
        setshowLoading(true);
        api_POST(`GeoCoding/GetPositionEndereco`, chave).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'warning', null);
            }
            else {
                try {
                    setCenter([result?.data?.latitude?.replace(",", "."), result?.data?.longitude?.replace(",", ".")]);
                    setPositionEndereco([result?.data?.latitude?.replace(",", "."), result?.data?.longitude?.replace(",", ".")]);
                }
                catch {
                    showMessage("Não foi possível localizar as coordenadas do endereço.", "Informe no mapa a localização!", 'warning', null);
                }
            }
        });
    }
    
    const handleMarkerPosition = event => {
        setPositionEndereco([event.target.getLatLng().lat, event.target.getLatLng().lng]);        
    }

    const onSubmit = (data) => {    
        
        if (status == "")
        {
            setError("status");
            return;
        }

        if(comprovanteDestinacao == ""){
            setError("comprovanteDestinacao");
            return;
        }

        let json_submit = {
            destinoId: item == null ? 0 : item.destinoId,
            identificacao: data.identificacao,
            cnpj: cnpj.replaceAll(".", "").replaceAll("/", "").replaceAll("-", "").replaceAll("_", ""),
            razaoSocial: data.razaosocial,
            ativo: (status == "Ativo" ? true : false),
            cep: cep,
            logradouro: data.logradouro,
            numeroLogradouro: data.numero,            
            bairro: data.bairro,
            cidade: data.cidade,
            uf: data.uf,
            latitude: positionEndereco[0],
            longitude: positionEndereco[1],
            usuarioCadastroId: session.usuarioId,
            usuarioAtualizacaoId: session.usuarioId,
            comprovanteDestinacao: comprovanteDestinacao
        }

        setshowLoading(true);
        if(json_submit.destinoId == 0){
            api_POST('Destino',json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error' , null);
                }
                else{
                    showMessage("Aviso", "Operação executada com sucesso!", 'success' , function(){
                        handleReturn(result.data);
                    });
                }
            });
        }
        else{
            api_PUT('Destino',json_submit).then(result => {
                setshowLoading(false);
                if (result.status !== 200) {
                    showMessage("Aviso", result.message, 'error' , null);
                }
                else{
                    showMessage("Aviso", "Operação executada com sucesso!", 'success' , function(){
                        handleReturn(result.data);
                    });
                }
            });
        }
    };

    useEffect(() => {        
        setValue("identificacao", item == null ? "" : item.identificacao);                
        setValue("razaosocial", item == null ? "" : item.razaoSocial);        
        if (item != null){
            setStatus(item.ativo ? "Ativo" : "Inativo");
            setCnpj(item.cnpj);                        
            setValue("cep", item.cep);
            setCep(item.cep);
            setValue("logradouro", item.logradouro);
            setValue("numero", item.numeroLogradouro);            
            setValue("bairro", item.bairro);
            setValue("cidade", item.cidade);
            setValue("uf", item.uf);
            setComprovanteDestinacao(item.comprovanteDestinacao);            
            if (item.latitude != null)
            {
                setPositionEndereco([item.latitude, item.longitude]);
                setCenter([item.latitude, item.longitude]);
            }
        }
    }, [item]);

    return (
    <>       
    {showLoading && 
          <div className="carregandoCmp">
              <div className="box">
                <label style={{marginRight:"20px"}}>Carregando...</label>
                <Spinner size="sm" color="info" />
              </div>
          </div> 
        }               
        <Row>
            <Container fluid>
                <Card className="shadow">
                    <CardHeader className="border-0">
                        <strong> Cadastro de Destinos</strong>
                    </CardHeader>
                    <CardBody>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Row>
                                <Col md="6" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Identificação
                                        </label>
                                        <Input                                            
                                            name="identificacao"
                                            placeholder="Identificação"
                                            type="text"
                                            maxLength={200} 
                                            innerRef={register({ required: true})}                                        
                                        />
                                        {errors.identificacao && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                                <Col md="6" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * CNPJ
                                        </label>
                                        <InputCNPJ                                                
                                            name="cnpj"
                                            placeholder="CNPJ"
                                            value={cnpj}                                            
                                            onChange={handleCNPJ}  
                                            inputRef={register({ required: true})}                                        
                                        />
                                        {errors.cnpj && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col> 
                                <Col md="6" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Razão Social
                                        </label>
                                        <Input                                            
                                            name="razaosocial"
                                            placeholder="Razão Social"
                                            type="text"
                                            maxLength={200} 
                                            innerRef={register({ required: true})}                                        
                                        />
                                        {errors.razaosocial && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>                                                                                        
                                <Col md="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Status
                                        </label>
                                        <Select
                                            options={options_status}
                                            name="status"
                                            onChange={(e) => {handleStatus(e.value)}}
                                            value={options_status.find(obj => obj.value === status)}
                                            placeholder="Selecione"                                                                             
                                        />
                                        {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>
                            </Row>                            
                            <Row>
                                <Col md="4" lg="2">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            * CEP
                                        </label>
                                        <InputCEP                                                
                                            name="cep"
                                            placeholder="Cep"
                                            value={cep}
                                            onChange={handleCEP}                                                                                          
                                            inputRef={register({ required: true})}                                            
                                        />  
                                        {errors.cep && <span className="form-control-label text-danger">* Campo Obrigatório</span>}                                          
                                    </FormGroup>
                                </Col>
                                <Col md="8" lg="6">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            * Logradouro
                                        </label>
                                        <Input                                                
                                            name="logradouro"
                                            placeholder="Logradouro"
                                            type="text"                                            
                                            innerRef={register()}
                                        />                                            
                                    </FormGroup>
                                </Col>
                                <Col md="4" lg="2">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            * Número
                                        </label>
                                        <Input                                                
                                            name="numero"
                                            placeholder="Número"
                                            type="number"
                                            onBlur={handleNumeroEndereco}  
                                            innerRef={register()}
                                        />            
                                        {errors.numero && <span className="form-control-label text-danger">* Campo Obrigatório</span>}                                
                                    </FormGroup>
                                </Col>                                
                                <Col md="4" lg="6">
                                    <FormGroup>
                                        <label className="form-control-label" htmlFor="input-address" >
                                            * Bairro
                                        </label>
                                        <Input                                                
                                            name="bairro"
                                            placeholder="Bairro"
                                            type="text"                                            
                                            innerRef={register()}
                                        />                                            
                                    </FormGroup>
                                    <Input                                                
                                            name="cidade"
                                            placeholder="cidade"
                                            type="hidden"                                            
                                            innerRef={register()}
                                        />                                            
                                        <Input                                                
                                            name="uf"
                                            placeholder="uf"
                                            type="hidden"                                            
                                            innerRef={register()}
                                        />                                            
                                </Col> 
                                <Col md="4" lg="4">
                                    <FormGroup>
                                        <label className="form-control-label"  >
                                        * Comprovante Destinação
                                        </label>
                                        <Select
                                            options={options_comprovanteDestinacao}
                                            name="comprovanteDestinacao"
                                            onChange={(e) => {handleComprovanteDestinacao(e.value)}}
                                            value={options_comprovanteDestinacao.find(obj => obj.value === comprovanteDestinacao)}
                                            placeholder="Selecione"                                                                             
                                        />
                                        {errors.status && <span className="form-control-label text-danger">* Campo Obrigatório</span>}
                                    </FormGroup>
                                </Col>                         
                            </Row>
                            <Row className="mt-4">
                                <Col md="12">
                                    <h4>Confirme no mapa a geolocalização do endereço</h4>
                                </Col>
                                <Col md="12">                                                                    
                                    <div id="map">
                                        <Map center={center} zoom={13} style={{zIndex:"0"}}>
                                        <TileLayer
                                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                        />           

                                        <Marker position={positionEndereco} draggable={true} icon={icon_destino} onDragend={handleMarkerPosition}></Marker>

                                    </Map>
                                    </div>
                                </Col>
                            </Row>                            
                            <Row>
                                <Col md="12" className="text-center">                                
                                <label className="form-control-label"></label>
                                <FormGroup>
                                    <Button color="warning" type="button" onClick={() => {handleReturn()}}>Voltar</Button>
                                    <Button color="success">Salvar</Button>
                                </FormGroup>
                                </Col>
                            </Row>

                        </form>
                    </CardBody>
                </Card>
            </Container>
        </Row>        
    </>
    );
}
